export enum USER_TYPE {
    ADMIN = 2,
    USER = 1,
}
